import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import MasterLayout from '../AppLayout/MasterLayout';
import CollectionsAppLayout from '../AppLayout/Collections/CollectionsAppLayout';
import { routes } from '../../constants';
import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { Link } from 'found';
import { customSizes } from '../../assets/styles/themes/tokens';
import { AsyncActionStatus } from '../../actions/common.actionTypes';
import { ContentItem } from '../../types/AppContent';
import useResponsivePadding from '../../utils/useResponsivePadding';
import ItemsList from '../ItemsList';
import { NotificationContext } from '../../state/NotificationContextProvider';
import { Alert } from '../NotificationAlert/NotificationAlert';
interface MyDownloadsProps {
  downloadStatus: AsyncActionStatus;
  downloadedItems: ContentItem[];
}

const MyDownloads: React.FC<MyDownloadsProps> = (props) => {
  const { downloadStatus, downloadedItems } = props;
  const { t } = useTranslation();
  const contentPadding = useResponsivePadding();
  const { showNotification } = useContext(NotificationContext);

  const handleShowNotification = (alert: Alert) => {
    showNotification(alert);
  };
    
  const renderMyDownloads = () => {
    if (downloadStatus !== 'loading' && (!downloadedItems || !downloadedItems.length)) {
      return (          
        <EmptySearchStateImage
          title={t('no downloads yet')}
          subtitle={
            <Trans 
              i18nKey='Start searching for the right content to download!' 
              key={1}
            >
              <Link to={`/${routes.search.root}`}></Link>
            </Trans>
          }
          subtitleSx={{ maxWidth: customSizes.emptyStateSubtitleMaxWidth, textAlign: 'center' }}
          iconName='emptyState'
        />
      );
    }

    return (
      <Box sx={{ position: 'relative' }} data-testid='my-downloads-list'>
        <ItemsList
          isLoading={downloadStatus === 'loading'}
          hasNext={false}
          total={downloadStatus === 'loading' ? -1 : downloadedItems.length}
          loadNext={() => {}}
          items={downloadedItems}
          linkRoot={[routes.downloads.root]}
          onShowNotification={handleShowNotification}
        />
      </Box>
    );
  };

  return (
    <Box data-testid='my-downloads-page'>
      <MasterLayout isNewMerklistePage={true}>
        <CollectionsAppLayout
          title={t('Downloads')}
          subtext={downloadedItems.length.toString()}
          isSearchPageContainer={true}
        >
          <Box sx={{ padding: contentPadding }}>
            {renderMyDownloads()}
          </Box>
        </CollectionsAppLayout>
      </MasterLayout>
    </Box>
  );
};

export default MyDownloads;
